import { Ref, ref, computed } from "vue";
import { YuukyuuKanriService } from "@/service/YuukyuuKanriService"

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(0); // APIで読み込みをする本数
  const isError = ref(false);
  
  const service = new YuukyuuKanriService()

  // 有給休暇管理台帳情報取得
  const getDaichouInfo = async (code: number) => {
    loading.value++
    const res = await service.getKanriDaichouInfo(code)
    loading.value--
    return res
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  // ユーザー情報を取得する

  return {
    isLoading,
    isError,
    getDaichouInfo,
  }
}
